// Dashboard
import Dashboard from '../modules/Dashboard/Dashboard';

// Transport
import Sales from '../modules/Transport/components/Sales/Sales';
import Purchasing from '../modules/Transport/components/Purchasing/Purchasing';
import DriverManagement from '../modules/Transport/components/DriverManagement/DriverManagement';

// User Management
import UserList from '../modules/UserManagement/User_list';
import { User_create } from '../modules/UserManagement/User_create';
import User_profile from '../modules/UserManagement/User_profile';
import User_group from '../modules/UserManagement/User_group';
import AddGroup from '../modules/UserManagement/User_group_create';
import EditGroup from '../modules/UserManagement/User_group_update';

// Platform Management
import BikeManagement from '../modules/PlatformManagement/BikeManagement';
import BikeAddModel from '../modules/PlatformManagement/Bike_model_create/components/BikeAddModel';
import BikeAddVariant from '../modules/PlatformManagement/Bike_variant_create/components/BikeAddVariant';
import BikeDetail from '../modules/PlatformManagement/Bike_model_update';
import LeadOMConfigure from '../modules/PlatformManagement/Lead-o-matic_update';
import AddLocation from '../modules/PlatformManagement/Lead-o-matic_location_create';
import EditLocation from '../modules/PlatformManagement/Lead-o-matic_location_update';
import PriceOMConfigure from '../modules/PlatformManagement/Price-o-matic_update';
import Manage_affiliates from '../modules/PlatformManagement/Manage_affiliates/index';
import Manage_affiliates_create from '../modules/PlatformManagement/Manage_affiliates_create/index';

// Leads
import Leads from '../modules/Leads/Manage_retail';
// import LeadsLeado from "../modules/Leads/Manage_leadomatic";
import ManagerSpecial from '../modules/Leads/Manager_special';
import Lead_create from '../modules/Leads/Lead_create';
import Lead_approval from '../modules/Leads/Lead_approval';
import LeadProfileView from '../modules/Leads/Lead_profile/components';
import LeadPaymentApproval from '../modules/Leads/LeadPaymentApproval';
import CustomersList from '../modules/Leads/CustomersList';

export const routes = [
    // Dashboard
    { path: '/Dashboard', component: Dashboard, URL: 'view://Dashboard/Dashboard' },

    // User Management
    { path: '/UserManagement/User_list', component: UserList, URL: 'view://UserManagement/User_list' },
    { path: '/UserManagement/User_create', component: User_create, URL: 'view://UserManagement/User_create' },
    { path: '/UserManagement/User_profile/:id', component: User_profile, URL: 'view://UserManagement/User_profile' },
    { path: '/UserManagement/User_group', component: User_group, URL: 'view://UserManagement/User_group' },
    { path: '/UserManagement/User_group_create', component: AddGroup, URL: 'view://UserManagement/User_group_create' },
    { path: '/UserManagement/User_group_update/:id', component: EditGroup, URL: 'view://UserManagement/User_group_update' },

    // Platform Management
    { path: '/PlatformManagement/BikeManagement', component: BikeManagement, URL: 'view://PlatformManagement/BikeManagement' },
    { path: '/PlatformManagement/Bike_model_create', component: BikeAddModel, URL: 'view://PlatformManagement/Bike_model_create' },
    { path: '/PlatformManagement/Bike_variant_create', component: BikeAddVariant, URL: 'view://PlatformManagement/Bike_variant_create' },
    { path: '/PlatformManagement/Bike_model_update/:id', component: BikeDetail, URL: 'view://PlatformManagement/Bike_model_update' },
    { path: '/PlatformManagement/Lead-o-matic_update', component: LeadOMConfigure, URL: 'view://PlatformManagement/Lead-o-matic_update' },
    { path: '/PlatformManagement/Lead-o-matic_update/location/add', component: AddLocation, URL: 'view://PlatformManagement/Lead-o-matic_location_create' },
    { path: '/PlatformManagement/Lead-o-matic_update/location/edit/:id', component: EditLocation, URL: 'view://PlatformManagement/Lead-o-matic_location_update' },
    { path: '/PlatformManagement/Price-o-matic_update', component: PriceOMConfigure, URL: 'view://PlatformManagement/Price-o-matic_update' },
    { path: '/PlatformManagement/Manage_affiliates', component: Manage_affiliates, URL: 'view://PlatformManagement/Manage_affiliates' },
    { path: '/PlatformManagement/Affiliate_create', component: Manage_affiliates_create, URL: 'view://PlatformManagement/Affiliate_create' },

    // Leads
    { path: '/Leads/Manage', component: Leads, URL: 'view://Leads/Manage' },
    { path: '/Leads/ManageLeadomatic', component: Leads, URL: 'view://Leads/ManageLeadomatic' },
    { path: '/Leads/ManageDeliveryRequested', component: Leads, URL: 'view://Leads/ManageDeliveryRequested' },
    { path: '/Leads/Manager_special', component: ManagerSpecial, URL: 'view://Leads/Manager_special' },
    { path: '/Leads/Lead_create', component: Lead_create, URL: 'view://Leads/Lead_create' },
    { path: '/Leads/Lead_approval', component: Lead_approval, URL: 'view://Leads/Lead_approval' },
    { path: '/Leads/Lead_profile/:id', component: LeadProfileView, URL: 'view://Leads/Lead_profile' },
    { path: '/Leads/LeadPaymentApproval', component: LeadPaymentApproval, URL: 'view://Leads/LeadPaymentApproval' },
    { path: '/Leads/customers-list', component: CustomersList, URL: 'view://Leads/CustomersList' },

    // Transport
    { path: '/Transport/Sales', component: Sales },
    { path: '/Transport/Purchasing', component: Purchasing },
    { path: '/Transport/Driver_management', component: DriverManagement },
];

export const routesByUrl = routes.reduce((accumulator, route) => {
    accumulator[route.URL] = route;
    return accumulator;
}, {});



// WEBPACK FOOTER //
// ./src/router/route.config.js